<template>
  <div>
    <loading v-if="showLoading"></loading>
    <Breadcrumb v-bind:data="BreadcrumbList"></Breadcrumb>
    <account-status :account_status="account_status"></account-status>

    <div class="widget has-shadow">

      <div class="widget-header bordered  d-flex align-items-center">
        <h2>مدیریت محموله ها</h2>
      </div>

      <div class="widget-body">

        <div v-if="account_status=='active'">
          <div class="search_form order_search">
            <input
              type="text"
              v-model="search_package_id"
              placeholder="شماره محموله"
              class="form-control"
              style="margin-left:10px"
            />
            <pdatepicker
              v-model="date"
              placeholder="تاریخ ثبت محموله"
              input-class="form-control"
              hover-day-back-color="#00bfd6"
              header-background-color="#00bfd6"
              chosen-day-back-color="#00bfd6"
            ></pdatepicker>

            <button
              class="btn btn-primary"
              v-on:click="getPackage(1)"
              style="margin-right:10px"
            >جست و جو</button>
          </div>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>شناسه محموله</th>
                <th>زمان ارسال</th>
                <th>تعداد محصول</th>
                <th>وضعیت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row,key) in list.data" :key="key">
                <td>{{ getRow(key) }}</td>
                <td>{{ replaceNumber(row.package_id) }}</td>
                <td>{{ replaceNumber(row.send_date) }}</td>
                <td>{{ replaceNumber(row.product_count) }}</td>
                <td>{{ package_status(row.status) }}</td>
                <td>
                  <span
                    class="fa fa-eye"
                    v-on:click="$router.push({name:'PackageContent',params:{id:row.id}})"
                  ></span>
                </td>
              </tr>
              <tr v-if="list.data.length==0">
                <td colspan="6">رکوردی یافت نشد</td>
              </tr>
            </tbody>
          </table>

          <pagination :data="list" @pagination-change-page="getPackage"></pagination>
        </div>
        <div v-else>
          <p style="padding-top:100px;text-align:center;font-size:50px">
            <span class="fa fa-exclamation"></span>
          </p>
          <p
            style="text-align:center;padding-bottom:80px"
          >شما دسترسی لازم برای عملیات جاری را ندارید</p>
        </div>
      </div>
    </div>
    <server-error-message v-if="server_error"></server-error-message>
  </div>
</template>

<script>
import myMinix from "../myMixin";
export default {
  mixins: [myMinix],
  data() {
    return {
      showLoading: false,
      server_error: false,
      account_status: "active",
      BreadcrumbList: [{ path: "/package", title: "مدیریت محموله ها" }],
      date: "",
      search_package_id: "",
      list: { data: [] },
      page: 1
    };
  },
  mounted() {
    this.account_status = localStorage.getItem("account_status");
    this.$emit("setSideBarItem", "package");
    this.getPackage(1);
  },
  methods: {
    getPackage: function(page = 1) {
      this.page = 1;
      this.showLoading = true;
      const url =
        this.$siteUrl +
        "/api/seller/packages?page=" +
        page +
        "&package_id=" +
        this.search_package_id +
        "&date=" +
        this.date;
      this.axios
        .get(url, this.setHeader())
        .then(response => {
          this.showLoading = false;
          const result = this.setAccountStatus(response.data);
          if (result) {
            this.list = response.data;
          }
        })
        .catch(error => {
          this.setCatch(error);
        });
    }
  }
};
</script>

<style>
</style>